import { createBridgeComponent } from '@module-federation/bridge-react';

import { App } from './app';

const provider = createBridgeComponent({
  rootComponent: App,
});

export default provider;
